import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import LockIcon from '@material-ui/icons/Lock';

export default function BlockedIcon() {
    return <Tooltip title={'Заблокирован'} placement="top">
        <LockIcon style={{ color: '#de7d55' }} />
    </Tooltip>;
}